<template>
  <div class="APIHomepage">
    <div class="title">API Application Platform</div>
    <div class="title-desc">
      After selecting the API interface you want, the system will provide you
      with a packaged download file
    </div>
    <div class="contentlist-box">
      <el-checkbox-group v-model="apicheckList" class="api-checkbox-group">
        <div
          :class="['api-modules', item.themeCssName]"
          v-for="(item, index) in apiDataCategoryList"
          :key="index"
           @click="toAPIHomepage_more(item)"
        >
          <div class="api-topbox">
            <div class="api-leftbox">
              <el-checkbox class="api-checkbox"  :label="item.id"
              @click.native.stop
              v-if="TesRecordsPageData.isShowCheckBtn_APIH"
              ></el-checkbox>
              <div class="apiImgBox">
                <img
                  src="../../../assets/images/dataServices/dataapi-img/apiimg1.svg"
                  alt=""
                  class="api-img"
                />
              </div>
              <div class="api-titletag">
                <div class="api-title">{{ item.categoryName }}</div>
                <div class="api-tag">
                  <el-tag
                    v-for="(i, idx) in item.labelList"
                    :key="idx"
                    :class="'COLOR_'+i.labelColor"
                  >
                    {{ i.labelName }}
                  </el-tag>
                </div>
              </div>
            </div>
            <!-- <div class="right-apiDetail">
              <img
                src="../../../assets/images/dataServices/dataapi-img/chevron-right.png"
                alt=""
              />
            </div> -->
          </div>
          <div class="api-desc">
            {{ item.description || "--" }}
          </div>
          <div class="api-date-btn">
            <div class="api-update">
              Update time：{{
                $formatDateTime(item.updateTime, "yyyy-MM-dd hh:mm:ss")
              }}
            </div>
            <div>
              <el-button class="api-apply-btn" @click.stop="applyforTest(item)"
                >Apply for Test</el-button
              >
            </div>
          </div>
        </div>
      </el-checkbox-group>
    </div>
    <!-- 申请测试 -->
    <ApplyForTestDialogVue :applyDialogVisible="applyDialogVisible" :applyfortestForm="applyfortestForm" @getAPPKey='getAPPKey' @getSecretKey='getSecretKey' @closeApplyforTestVisible="closeApplyforTestVisible" @toGenerateClick='toGenerateClick' ></ApplyForTestDialogVue>
   </div>
</template>

<script>
import {
  getApiDataCategory,
  generateAppKeyInfo,
  applyAccount,
  getApiDataApiPage,
} from "@/api/dataServicesApi";
import crypto from "@/utils/crypto";
import ApplyForTestDialogVue from '../components/applyForTestDialog.vue';

export default {
  props: ['TesRecordsPageData'],
  data() {
    return {
      apiDataCategoryList: [],
      apicheckList: [], // 存储已选中的 ID
      applyfortestForm: {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      },
      applyDialogVisible: false,
    };
  },
  components: {
    ApplyForTestDialogVue
  },
  computed: {},
  watch: {
    TesRecordsPageData: {
      handler(newVal) {
        // 检查目标属性是否变化
        console.log('newVal--',newVal);
        if (newVal &&( newVal.isReselectCheckBtn_APIH||newVal.isShowCheckBtn_APIH)) {
          // 如果点击了select 和reselect工具按钮isShowCheckBtn_APIH(点击select显示多选框 多选框重置)或者 isReselectCheckBtn_APIH为true 则重置选中的多选框
          if(this.apicheckList==[]) return
          this.apicheckList=[]
        }
      },
      deep: true, // 必须开启深度监听
      immediate: true // 如果需要初始化时也执行一次
    },
    apicheckList: {
      handler(newVal) {
        // 检查目标属性是否变化
        if (newVal) {
           // 触发事件，把数据发给父组件
           this.$emit('update-selection', newVal,'1');
        }
      },
      deep: true, // 必须开启深度监听
      // immediate: true // 如果需要初始化时也执行一次
    }
  },
  created() {
  },
  mounted() {
    this.getApiDataCategoryList();
  },
  methods: {
    getApiModules() {
      // 给每个模块添加主题色
      this.apiDataCategoryList = this.apiDataCategoryList.map(
        (item, index) => ({
          ...item,
          // 给每个模块添加主题色
          themeCssName: ["yellowTheme", "purpleTheme", "blueTheme"][index % 3],
        })
      );
    },
    // 获取api列表
    getApiDataCategoryList() {
      let loading =this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
        });
      //根据分类名称获取标签精准查询的参数
      let params = {
        // categoryName:"测试",
        // labelIds:[1,2]
      };
      console.log('loading--',loading);
      getApiDataCategory(params).then((res) => {
        if (res.code == 200) {
          this.apiDataCategoryList = JSON.parse(JSON.stringify(res.data));
          this.getApiModules();
          loading.close();
        } else {
          this.$message.error(res.msg);
          loading.close();
        }
      });
    },
    // 申请
    async applyforTest(row) {
      this.applyRow = row; //当前点击申请的一级信息
      // 获取账号信息
      await generateAppKeyInfo().then((res) => {
        if (res.code == 200) {
          let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
          // 解密密码
          generateAppKeyInfo.secretKey = crypto.decrypt(
            generateAppKeyInfo.secretKey
          );
          this.applyDialogVisible = true;
          this.applyfortestForm = JSON.parse(
            JSON.stringify(generateAppKeyInfo)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // copy appkey secretKey
    async getAPPKey() {
      this.copyTool(this.applyfortestForm.appKey);
    },
    getSecretKey() {
      this.copyTool(this.applyfortestForm.secretKey);
    },
    async copyTool(data) {
      try {
        await this.$copyText(data)
        this.$message({
          message: "Copied",
          type: "success",
        });
      } catch (err) {
        this.$message({
          message: "Failed to copy: " + err,
          type: "warning",
        });
      }
    },
    closeApplyforTestVisible() {
      this.applyDialogVisible = false;
      this.applyfortestForm = {
        appKey: "",
        secretKey: "",
        createTime: "",
        days: "",
        callCount: "",
      };
    },
    // 生成
    async toGenerateClick() {
      try {
        console.log("点击了");
        let params1 = {
          page: 1,
          pageSize: 300, //获取二级的所有数据
          categoryId: this.applyRow.id, //一级分类id
        };
        let res1 = await getApiDataApiPage(params1); // 先获取所有二级分类的id
        if (res1.code != 200) {
          this.$message.error(res1.msg);
          return;
        }
        let apiIdArr = res1.data.rows.map((item) => item.id);
        console.log("res1", res1);
        let params2 = {
          appKey: this.applyfortestForm.appKey,
          apiId: apiIdArr, //二级的分类id
          env: 1, //1是测试2是生产
        };
        let res2 = await applyAccount(params2);
        if (res2.code == 200) {
          if(res2.data.failApisNoRepeat&&res2.data.failApisNoRepeat.length){
            // 有重复的账号被申请
            this.$message.warning('Some APIs have already been applied. Only unapplied APIs will be processed in batch.');
            
          }else{
            this.$message.success(res2.msg);
          }
          // 跳转到账号管理页面
          this.$router.push({name:'AccountManagement'})
        } else {
          this.$message.error(res2.msg);
        }
        this.closeApplyforTestVisible();
        console.log("全部成功-res2", res2);
      } catch (error) {
        console.log("error", error);
      }
    },
    // 跳转到二级
    toAPIHomepage_more(row) {
      console.log('跳转二级需要的数据',row);
      this.$router.push({
        name: "APIHomepage_more",
        query: { id: row.id, categoryName: row.categoryName },
      });
    },
  },
};
</script>

<style scoped>
.APIHomepage .title {
  font-weight: bold;
  font-size: 22px;
  color: #1a2332;
  margin-bottom: 12px;
}
.APIHomepage .title-desc {
  font-size: 18px;
  color: #666666;
  margin-bottom: 22px;
}
.APIHomepage .api-checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.api-modules {
  border: 1px solid #ebebeb;
  border-radius: 10px;
  padding: 26px;
  background: white;
  cursor: pointer;
  display: flex;
    flex-direction: column;
    height: 100%;
}
  .api-modules .api-date-btn{
    margin-top:auto;
  }
.api-topbox {
  border-bottom: 1px #eeeeee solid;
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  justify-content: space-between; /* 左右两端对齐 */
  padding: 12px 0; /* 上下内边距 */
}
.api-topbox .api-leftbox {
  display: flex;
  align-items: center;
}
/* 复选框 + 图标 区域 */
.api-topbox .api-checkbox {
  margin-right: 26px;
}
.api-topbox .api-checkbox /deep/ .el-checkbox__label {
  display: none !important;
}
.api-topbox .api-titletag {
  margin-left: 26px;
}
.api-modules .api-topbox .apiImgBox {
  /* width: 58px; */
  flex: 0 0 58px;/* 不增长、不收缩、基础宽度 300px */
  height: 58px;
  border-radius: 10px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.api-modules.yellowTheme .api-topbox .apiImgBox {
  background: #ffbc7d !important;
}
.api-modules.purpleTheme .api-topbox .apiImgBox {
  background: #c2c5f8 !important;
}
.api-modules.blueTheme .api-topbox .apiImgBox {
  background: #b5d1f7 !important;
}
/* 主标题 */
.api-topbox .api-title {
  font-weight: bold;
  font-size: 20px;
  color: #1a2332;
  margin-bottom: 4px;
  min-width:300px;
}
/* 标签区域 */
.api-topbox .api-tag {
  display: flex;
  flex-wrap:wrap;
  gap: 8px;
}

/* 一级标签样式（可选） */
.COLOR_F5F5F5 {
  background-color: #f5f5f5;
  color: #666666;
  border: none;
}
.COLOR_E6F3FF {
  background-color: #e6f3ff;
  color: #003366;
  border: none;
}
.COLOR_E6FFE6 {
  background-color: #e6ffe6;
  color: #006633;
  border: none;
}
.COLOR_FFF2E6 {
  background-color: #fff2e6;
  color: #993300;
  border: none;
}
.COLOR_F0F0FF {
  background-color: #f0f0ff;
  color: #333399;
  border: none;
}
.COLOR_FFFFE6 {
  background-color: #ffffe6;
  color: #999900;
  border: none;
}
.COLOR_E6FFEE {
  background-color: #e6ffee;
  color: #009966;
  border: none;
}
.COLOR_FFE6F2 {
  background-color: #ffe6f2;
  color: #990066;
  border: none;
}
.COLOR_E6F8FF {
  background-color: #e6f8ff;
  color: #006699;
  border: none;
}
.COLOR_F2E6FF {
  background-color: #F2E6FF;
  color: #663399;
  border: none;
}
/* 右箭头 */
.api-topbox .right-apiDetail img {
  width: 24px;
  height: 24px;
}

.api-modules .api-desc {
  font-size: 18px;
  color: #666666;
  margin-bottom: 14px;
  padding: 14px 0;
  /* min-height: 75px; */
}
.api-modules .api-update {
  font-size: 18px;
  color: #999999;
}
.api-modules .api-apply-btn {
  color: #fff;
  padding: 10px 20px;
}
.api-modules .api-date-btn {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  justify-content: space-between; /* 左右两端对齐 */
}
.api-modules .api-apply-btn {
  visibility: hidden;
  opacity: 0;
}
/* 鼠标移入样式 */
.api-modules.yellowTheme:hover {
  border: 1px solid #ffbc7d;
}
.api-modules.purpleTheme:hover {
  border: 1px solid #c2c5f8;
}
.api-modules.blueTheme:hover {
  border: 1px solid #b5d1f7;
}
.api-modules:hover .api-apply-btn {
  visibility: visible;
  opacity: 1;
}
.api-modules.yellowTheme .api-apply-btn {
  background: #ffbc7d !important;
}
.api-modules.purpleTheme .api-apply-btn {
  background: #c2c5f8 !important;
}
.api-modules.blueTheme .api-apply-btn {
  background: #b5d1f7 !important;
}


/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
/* 字体 标题改成20px */
.APIHomepage .title{
  font-size:20px;
}
/* 字体 内容改成16px 包括按钮里字体*/
.APIHomepage .title-desc,.api-tag .el-tag,.api-modules .api-desc,.api-modules .api-update,.dataServices-theme .el-button{
  font-size:16px!important;
}
/* 圆角 改成10px */
.api-tag .el-tag{
  border-radius:10px;
}
/* padding *0.75 */
.api-modules{
  padding:20px;
}
}
@media (max-width: 1440px) {
/* 字体 标题改成18px */
.APIHomepage .title,.api-topbox .api-title{
  font-size:18px;
}
/* 字体 内容改成14px 包括按钮里字体*/
.APIHomepage .title-desc,.api-tag .el-tag,.api-modules .api-desc,.api-modules .api-update,.dataServices-theme .el-button{
  font-size:14px!important;
}
/* 圆角 改成8px */
.api-tag .el-tag{
  border-radius:8px;
}
/* padding *0.67 */
.api-modules{
  padding:18px;
}
}
</style>
